webpackJsonp([199482085584678],{

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PaymentsDetailsSectionModule = __webpack_require__(660);
	
	var _PaymentsDetailsSectionModule2 = _interopRequireDefault(_PaymentsDetailsSectionModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	var _ButtonLink = __webpack_require__(14);
	
	var _ButtonLink2 = _interopRequireDefault(_ButtonLink);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _imgPeopleMonitoring = __webpack_require__(797);
	
	var _imgPeopleMonitoring2 = _interopRequireDefault(_imgPeopleMonitoring);
	
	var _imgPeopleMonitoring2x = __webpack_require__(798);
	
	var _imgPeopleMonitoring2x2 = _interopRequireDefault(_imgPeopleMonitoring2x);
	
	var _imgPeopleMonitoring3x = __webpack_require__(799);
	
	var _imgPeopleMonitoring3x2 = _interopRequireDefault(_imgPeopleMonitoring3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'src-components----PaymentsDetailsSection-module---payments-details-section---3Eqxv' },
	        _react2.default.createElement(
	            _reactstrap.Container,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'src-components----PaymentsDetailsSection-module---text-container---3x2PI' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2' },
	                    'They say you can\u2019t have it all'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2 text-blue' },
	                    'Fortunately, they\u2019re wrong.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-components----PaymentsDetailsSection-module---features-table---1aPw3' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----PaymentsDetailsSection-module---feature-row---3z1a-' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----PaymentsDetailsSection-module---heading---2bN3X' },
	                            'Improve cash flow'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Don\u2019t pay until you have to. Galleon times payments to take full advantage of your carriers\u2019 terms. You may also qualify for extended financing terms.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----PaymentsDetailsSection-module---feature-row---3z1a-' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----PaymentsDetailsSection-module---heading---2bN3X' },
	                            'Simplify bookkeeping'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Keep it simple. Instead of reconciling scores of invoices, Galleon will send you a single CSV \u2014 with accruals and GL coding already done \u2014 ready for direct upload into your books.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----PaymentsDetailsSection-module---feature-row---3z1a-' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----PaymentsDetailsSection-module---heading---2bN3X' },
	                            'Save more'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            'Get Galleon for cheap or free. Payments customers are eligible for deeply discounted or even waived fees on other Galleon services.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'src-components----PaymentsDetailsSection-module---feature-row---3z1a-' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'src-components----PaymentsDetailsSection-module---heading---2bN3X' },
	                            'Ready to learn more?'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            null,
	                            _react2.default.createElement(
	                                _ButtonLink2.default,
	                                { to: 'contact', className: 'mt-2' },
	                                'Contact us'
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'src-components----PaymentsDetailsSection-module---splash-image-container---1CkCL' },
	            _react2.default.createElement(_RetinaImage2.default, { srcSet: [_imgPeopleMonitoring2.default, _imgPeopleMonitoring2x2.default, _imgPeopleMonitoring3x2.default],
	                className: 'src-components----PaymentsDetailsSection-module---splash-image---3zPuR' })
	        )
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 660:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"payments-details-section":"src-components----PaymentsDetailsSection-module---payments-details-section---3Eqxv","text-container":"src-components----PaymentsDetailsSection-module---text-container---3x2PI","message":"src-components----PaymentsDetailsSection-module---message---1LKzv","features-table":"src-components----PaymentsDetailsSection-module---features-table---1aPw3","feature-row":"src-components----PaymentsDetailsSection-module---feature-row---3z1a-","heading":"src-components----PaymentsDetailsSection-module---heading---2bN3X","splash-image-container":"src-components----PaymentsDetailsSection-module---splash-image-container---1CkCL","splash-image":"src-components----PaymentsDetailsSection-module---splash-image---3zPuR"};

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-people-monitoring.063895f4.png";

/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-people-monitoring@2x.1ba5dad8.png";

/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-people-monitoring@3x.cf9094c0.png";

/***/ }),

/***/ 803:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-woman-working.4b21e500.jpg";

/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-woman-working@2x.143001dc.jpg";

/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-woman-working@3x.86ab3cb8.jpg";

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _dashboardModule = __webpack_require__(55);
	
	var _dashboardModule2 = _interopRequireDefault(_dashboardModule);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(3);
	
	var _Animations = __webpack_require__(5);
	
	var _RetinaImage = __webpack_require__(12);
	
	var _RetinaImage2 = _interopRequireDefault(_RetinaImage);
	
	var _FeaturesLinksSection = __webpack_require__(51);
	
	var _FeaturesLinksSection2 = _interopRequireDefault(_FeaturesLinksSection);
	
	var _TestimonialsSection = __webpack_require__(91);
	
	var _TestimonialsSection2 = _interopRequireDefault(_TestimonialsSection);
	
	var _PaymentsDetailsSection = __webpack_require__(370);
	
	var _PaymentsDetailsSection2 = _interopRequireDefault(_PaymentsDetailsSection);
	
	var _imgWomanWorking = __webpack_require__(803);
	
	var _imgWomanWorking2 = _interopRequireDefault(_imgWomanWorking);
	
	var _imgWomanWorking2x = __webpack_require__(804);
	
	var _imgWomanWorking2x2 = _interopRequireDefault(_imgWomanWorking2x);
	
	var _imgWomanWorking3x = __webpack_require__(805);
	
	var _imgWomanWorking3x2 = _interopRequireDefault(_imgWomanWorking3x);
	
	var _iconPayments = __webpack_require__(238);
	
	var _iconPayments2 = _interopRequireDefault(_iconPayments);
	
	var _iconPayments2x = __webpack_require__(239);
	
	var _iconPayments2x2 = _interopRequireDefault(_iconPayments2x);
	
	var _iconPayments3x = __webpack_require__(240);
	
	var _iconPayments3x2 = _interopRequireDefault(_iconPayments3x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'src-pages-features----dashboard-module---hero---RX6K-' },
	        _react2.default.createElement(
	            _reactstrap.Container,
	            null,
	            _react2.default.createElement(
	                'div',
	                { className: 'src-pages-features----dashboard-module---text-container---3CHyn' },
	                _react2.default.createElement(_RetinaImage2.default, { srcSet: [_iconPayments2.default, _iconPayments2x2.default, _iconPayments3x2.default] }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h1 mt-2' },
	                    'Payments'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'h2 text-blue' },
	                    'Take the pain out of parcel A/P.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'src-pages-features----dashboard-module---message---TYnoZ' },
	                    'Improve cash flow, radically simplify bookkeeping, and save even more money when you outsource your shipping A/P to Galleon. Great for shippers with complex shipping networks and meaningful spend.'
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Animations.ScrollOverPack,
	            { className: 'src-pages-features----dashboard-module---splash-image-container---1iBIF' },
	            _react2.default.createElement(_Animations.TweenOne, _extends({ key: '0',
	                component: _RetinaImage2.default,
	                srcSet: [_imgWomanWorking2.default, _imgWomanWorking2x2.default, _imgWomanWorking3x2.default],
	                className: 'src-pages-features----dashboard-module---splash-image---1LZSu'
	            }, _Animations.FadeLeft))
	        )
	    );
	};
	
	exports.default = function (props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(Hero, null),
	        _react2.default.createElement(_PaymentsDetailsSection2.default, null),
	        _react2.default.createElement(_TestimonialsSection2.default, null),
	        _react2.default.createElement(_FeaturesLinksSection2.default, null)
	    );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-features-payments-js-761812765b9f51a18ae1.js